import cn from 'classnames'
import { FC } from 'react'
import ReactMarkdown, { ReactMarkdownOptions } from 'react-markdown'

import styles from './Markdown.module.scss'

interface IMarkdownProps extends ReactMarkdownOptions {
  scrollable?: boolean
  children: string
  unnumerableList?: boolean
  dir?: 'ltr' | 'rtl'
}
const Markdown: FC<IMarkdownProps> = ({
  scrollable = true,
  children,
  unnumerableList,
  dir,
  ...rest
}) => {
  return (
    <div dir={dir} className={cn(styles.wrapper, { [styles.scrollable]: scrollable })}>
      {/* <div className={styles.observed} /> */}
      <ReactMarkdown
        className={cn(styles.md, { [styles.unnumerableList]: unnumerableList })}
        {...rest}
      >
        {children}
      </ReactMarkdown>
    </div>
  )
}

export default Markdown
